"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(require("./ExpansionPanelSummary"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ExpansionPanelSummary/index.js
// module id = 705
// module chunks = 0